import { useMutation } from '@tanstack/react-query';

import type { CreateEmployeeEmploymentArgs } from '../../../Domain/Employees/Services/EmployeeService';
import { employeeService } from '../../../Domain/Employees/Services/EmployeeService';

const mutationFn = (data: CreateEmployeeEmploymentArgs) => {
  return employeeService.createEmployeeEmployment(data);
};

export const useEmployeeCreateEmploymentMutation = () => {
  return useMutation<unknown, unknown, CreateEmployeeEmploymentArgs>(mutationFn);
};
